import { Link } from "react-router-dom";
import { ScrollSection } from "@/components/main-page/ScrollSection";

export function ClosingCTASection() {
  return (
    <ScrollSection id="contact" title="Let's talk" subtitle="We build for regulated industries. If that's yours, we should talk." compact>
      <div className="flex flex-wrap gap-4 mb-10">
        <Link
          to="/contact"
          className="inline-flex items-center px-6 py-3 rounded-full text-sm font-medium bg-[var(--color-fg)] text-[var(--color-bg)] hover:opacity-90 transition-opacity"
        >
          Get in touch
        </Link>
        <Link
          to="/about#careers"
          className="inline-flex items-center px-6 py-3 rounded-full text-sm font-medium border border-[var(--color-border)] text-[var(--color-fg-secondary)] hover:text-[var(--color-fg)] hover:border-[var(--color-fg-secondary)] transition-colors"
        >
          Work with us →
        </Link>
      </div>
      <div className="pt-6 border-t border-[var(--color-border)]">
        <span className="text-sm font-[family-name:var(--font-mono)] text-[var(--color-fg-tertiary)]">
          Say{" "}
          <a
            href="mailto:hi@cosx.co"
            className="hover:text-[var(--color-fg)] transition-colors"
          >
            hi@cosx.co
          </a>
          . We'll bring the coffee.
        </span>
      </div>
    </ScrollSection>
  );
}
